export default "__VITE_ASSET__DjhvSuzO__"